import { useQuery, useQueryClient } from 'react-query';

//consts
import { QUERY_KEYS } from 'consts/queryKeys';
//services
import { getProfileInfo } from 'services/api/apiCalls/settings';
import * as Logger from 'services/logger';
import { useThemeState } from 'services/theme/ThemeProvider';

const useQueryProfileInfo = (isAuthenticated: boolean) => {
  const queryClient = useQueryClient();
  const { changeTheme } = useThemeState();

  if (!isAuthenticated) {
    queryClient.removeQueries();
  }

  // Fetching profile info
  const {
    error: errProfileInfo,
    data: dataProfileInfo,
    isLoading: isLoadingProfileInfo,
  } = useQuery(QUERY_KEYS.SETTINGS_PROFILE, getProfileInfo, {
    enabled: isAuthenticated,
    staleTime: 1000 * 60 * 10,
    useErrorBoundary: (error: any) => error.response?.status >= 500,
    onSuccess: data => {
      const profile = data?.data;
      const customerId = profile?.customerId || '';

      window.localStorage.setItem('CUSTOMER_ID', customerId);

      if (profile) {
        Logger.setUser({
          identifier: profile.userId,
          email: profile.email,
          fullName: `${profile.firstName} ${profile.lastName}`,
          databaseName: profile.databaseName,
        });
      }

      if (customerId === 1011 || customerId === 276) {
        changeTheme('adriagate');
      } else {
        changeTheme('light');
      }
    },
  });

  return {
    isLoadingProfileInfo,
    errProfileInfo,
    profileInfo: dataProfileInfo?.data,
  };
};

export default useQueryProfileInfo;
